import { atom } from 'jotai'

// Atom to track if we're currently saving
export const isSavingWorkAtom = atom<boolean>(false)

// Atom to track the last save date
export const lastSaveWorkDateAtom = atom<Date>(new Date())

export const workTimeAtom = atom<number>(0)

// Atom to track the current solution
export const currentSolutionAtom = atom<string>('')

// Atom to track the current query
export const currentQueryAtom = atom<string>('')

// Atom to track the current notes (workspace notes tab)
export const currentNotesAtom = atom<string>('')

